export var ProductableType;

(function (ProductableType) {
  ProductableType["Pharmacy::Medicine::Identifier"] = "Pharmacy::Medicine::Identifier";
  ProductableType["MedicalCare::Examination"] = "MedicalCare::Examination";
  ProductableType["MedicalCare::WellnessProgram"] = "MedicalCare::WellnessProgram";
  ProductableType["MedicalCare::Treatment"] = "MedicalCare::Treatment";
  ProductableType["MedicalCare::OutpatientService"] = "MedicalCare::OutpatientService";
  ProductableType["MedicalCare::Therapy"] = "MedicalCare::Therapy";
})(ProductableType || (ProductableType = {}));

export var ItemableType;

(function (ItemableType) {
  ItemableType["Pharmacy::Medicine"] = "Pharmacy::Medicine";
  ItemableType["MedicalCare::Examination"] = "MedicalCare::Examination";
})(ItemableType || (ItemableType = {}));